import axios from 'axios';

export const AUTHENTICATED = 'authenticated_user';
export const UNAUTHENTICATED = 'unauthenticated_user';
export const AUTHENTICATION_ERROR = 'authentication_error';
export const SET_USER = 'SET_USER';
export const SET_LOCATION = 'SET_LOCATION';

const URL = '';

export function signInAction({ email, password }, history) {
  return async (dispatch) => {
    try {
      const res = await axios.post(`${URL}/login`, 
        {
          user: { 
            email,
            password 
          }
        }
      );

      dispatch(setUser(res.data));
      dispatch({ type: AUTHENTICATED });
      localStorage.setItem('token', res.headers.authorization.replace("Bearer ", ""));
      history.push('/');
    } catch(error) {
      dispatch({
        type: AUTHENTICATION_ERROR,
        payload: 'Invalid email or password'
      });
    }
  };
}

export function getUser(jwt) {
  return async (dispatch) => {
    const res = await axios.get(`${URL}/users/me`, { headers: { Authorization: `Bearer ${jwt}` } });

    dispatch(setUser(res.data));
    dispatch({ type: AUTHENTICATED });
  };
}

export function setUser(user) {
  return {
    type: SET_USER,
    user
  }
}

export function signOutAction() {
  localStorage.clear();
  document.title = "MenuMate"
  return {
    type: UNAUTHENTICATED
  };
}

export function setLocation(location) {
  return {
    type: SET_LOCATION,
    location
  }
}
